<template>
  <b-card
    body-class="pb-50"
  >
    <h6>{{obj.title}}</h6>
    <h2 class="font-weight-bolder mb-1">
      <!-- {{obj.series[0].data.reduce((accu, el) => accu + el, 0)}} -->
      {{obj.total}}

      <!-- <div class="">
        <b-form-select
          :options='timeFilter'
          text-field="text"
          value-field="id"
          v-model="formData.id"
          @input='changeFilter(graph, formData)'
        >
        </b-form-select>
      </div> -->
    </h2>
    <!-- chart -->
    <vue-apex-charts
      height="70"
      :options="statisticsOrder.chartOptions"
      :series="obj.series"
    />
  </b-card>
</template>

<script>
import { BCard , BFormSelect } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'

const $barColor = '#f3f3f3'

export default {
  components: {
    BCard,
    VueApexCharts,
    BFormSelect,
  },
  props: ['obj', 'filter', 'timeFilter', 'changeFilter'],
  data() {
    return {
      graph: 'orders',
      formData: {
        id: 1,
        laoding: true
      },
      statisticsOrder: {
        chartOptions: {
          chart: {
            type: 'bar',
            stacked: true,
            toolbar: {
              show: false,
            },
          },
          grid: {
            show: false,
            padding: {
              left: 0,
              right: 0,
              top: -15,
              bottom: -15,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '20%',
              startingShape: 'rounded',
              colors: {
                backgroundBarColors: [$barColor, $barColor, $barColor, $barColor, $barColor],
                backgroundBarRadius: 5,
              },
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          colors: [$themeColors.warning],

          xaxis: {
            labels: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
          },
          yaxis: {
            show: false,
          },
          tooltip: {
            x: {
              show: false,
            },
          },
        },
      },
    }
  },
}
</script>
